module.exports = __webpack_public_path__ + "img/plusTop.c9b460a8.svg";